export default __webpack_public_path__ + "static/media/bd.40a6f4d0.svg";